module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921072334_T.fbf42981.jpg";